import exceptionsOperations from './exceptionsOperations';
import resourcesOperations from './resourcesOperations';
import alternativesOperations from './alternativesOperations';

export default {
  ...exceptionsOperations,
  ...resourcesOperations,
  ...alternativesOperations
};
